import axios from 'axios'
import Api from '../config.json'
const globalhelper = {
  getGSTBearerToken: function () {
    if (localStorage.getItem('GSTauthorization')) {
      let loginData = localStorage.getItem('GSTauthorization')
      let AuthStr = 'Bearer ' + loginData
      return AuthStr
    } else {
      return ''
    }
  },
  isAuthendicated: function () {
    if (localStorage.getItem('loggin_data')) {
      return true
    } else {
      return false
    }
  },
  getBaseURI: function () {
    return 'http://localhost:8080api/'
  },
  getTimestamp: function (key) {
    let newDate = new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()
    return key === 'year' ? year : key === 'month' ? month : ''
  },
  currencyFormatter: function (value) {
    if (!value) {
      value = 0
    }
    if (typeof value === 'string') {
      value = Number(value)
    }
    const formatter = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  },
  reload: function () {
    setTimeout(() => {
      window.location.reload()
    }, 500)
  },
  sanitizeText: function (text = '') {
    let sanitizedText = `${text}`
    if (
      sanitizedText.indexOf('@') > -1 ||
      sanitizedText.indexOf('=') > -1 ||
      sanitizedText.indexOf('+') > -1 ||
      sanitizedText.indexOf('-') > -1
    ) {
      sanitizedText = `'${sanitizedText}`
    }
    return sanitizedText
  },
  debounce: function (func, wait = 300) {
    let timeout
    return function (...args) {
      const context = this
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(context, args), wait)
    }
  },
  roundOff: function (num, precision = 2) {
    if (isNaN(num) || num === null || num === undefined) {
      return 0
    }
    const factor = Math.pow(10, precision)
    return Math.round(Number(num) * factor) / factor
  },
  stringToColor: function (string) {
    let hash = 0;
    let i;
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  },
  gstZenLogin: async function (tenantID) {
    try {
      const params = new URLSearchParams();
      params.append('username', Api.gstZen[tenantID].username);
      params.append('password', Api.gstZen[tenantID].password);
      console.log(Api.gstZen[tenantID].username, Api.gstZen[tenantID].password);

      // If using the package.json proxy fix, change the URL to: '/accounts/api/login/token/'
      const response = await fetch(`/accounts/api/login/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString() // Explicitly passing stringified params for form data
      });

      // Check if the server response is in the 200-299 range
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data);

      if (data.access) {
        localStorage.setItem('GSTauthorization', data.access);
        return true;
      } else {
        return false;
      }

    } catch (error) {
      console.error("GSTZen Login Error:", error);
      return false;
    }
  },
  establishSessionByOTP: async function (otp, gstin, tenantID) {
    try {
      let response = await fetch(`/api/gstn-establish-session/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': globalhelper.getGSTBearerToken()
        },
        body: JSON.stringify({
          "gstin": gstin,
          "otp": otp
        })
      })

      const data = await response.json();
      console.log(data);
      if (response.ok) {
        if (data.expiry && data.expiry_time) {
          return true;
        }
      }
      return data;
    } catch (err) {
      console.log(err);
      return false;
    }

  }
}

export default globalhelper
